(function(){
    'use strict';

    if($('.smp-showcase-body').length) {
        $('.smp-showcase-body').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<button type="button" class="slick-prev"><span class="fas fa-chevron-left"></span><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="fas fa-chevron-right"></span><span class="sr-only">Next</span></button>',
            responsive: [
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '40px'
                }
              }
            ]
        });
    }

}());